// extracted by mini-css-extract-plugin
export default {"container":"Header_container__vI36D","user":"Header_user__v33aq","roleTag":"Header_roleTag__dJ42k"};